import LOGO from "../../2025_mens_a/images/Nogaleros.png";

export const Team__Nogaleras = {
  name: "Nogaleras",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#5ce673ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 4,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 16 + 25 + 37 + 24,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 27 + 31 + 40 + 26,
    },
  ],
};
